import { render, staticRenderFns } from "./NoMessageSelected.vue?vue&type=template&id=23d3f0b8&scoped=true"
import script from "./NoMessageSelected.vue?vue&type=script&lang=js"
export * from "./NoMessageSelected.vue?vue&type=script&lang=js"
import style0 from "./NoMessageSelected.vue?vue&type=style&index=0&id=23d3f0b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3f0b8",
  null
  
)

export default component.exports